import { Link } from "react-router-dom";
import { useSeo } from "../../lib/seo";

export default function NotFound() {
  useSeo({ title: "Page not found", robots: "noindex,nofollow" }, []);
  return (
    <section className="min-h-[70vh] bg-black text-white on-dark flex items-center" data-testid="not-found">
      <div className="container-x">
        <p className="eyebrow !text-white/60">Error 404</p>
        <h1 className="font-display text-6xl lg:text-8xl font-bold mt-4">Off the trail.</h1>
        <p className="mt-6 text-white/75 max-w-md">The page you're looking for doesn't exist or has moved.</p>
        <div className="mt-10 flex gap-4"><Link to="/" className="btn-light">Back home</Link><Link to="/experiences" className="btn-ghost-light">Browse experiences</Link></div>
      </div>
    </section>
  );
}
